/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReinclusaoRejeicaoFeedbackAliases {
  FIELD_DS_MOTIVO = 'field-dsMotivo',
  FIELD_DS_OBSERVACAO_REJEICAO = 'field-dsObservacaoRejeicao',
  FORM_REINCLUSAO_REJEICAO_FEEDBACK = 'form-reinclusao-rejeicao-feedback',
  PANEL_REINCLUSAO_REJEICAO_FEEDBACK = 'panel-reinclusao-rejeicao-feedback',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { ReinclusaoRejeicaoFeedbackAliases };
